document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.seoSectionCollection');

  sections.forEach(function (section) {
    var toggleContent = section.querySelector('[data-seo-toggle-content]');
    var mainCopy = section.querySelector('[data-seo-copy-main]');
    var extraCopy = section.querySelector('[data-seo-copy-extra]');
    var toggle = section.querySelector('[data-seo-toggle]');
    var collapsedHeight = 0;
    var hasAccordionContent = toggleContent && toggleContent.getAttribute('data-has-accordion-content') === 'true';

    if (!toggleContent || !mainCopy || !toggle) return;

    function isMobile() {
      return window.innerWidth < 768;
    }

    function getMobileCollapsedHeight() {
      var computedStyle = window.getComputedStyle(mainCopy);
      var lineHeight = parseFloat(computedStyle.lineHeight) || parseFloat(computedStyle.fontSize) * 1.6;

      return lineHeight * 4;
    }

    function getDesktopCollapsedHeight() {
      if (!extraCopy || !hasAccordionContent) return toggleContent.scrollHeight;

      return Math.ceil(mainCopy.getBoundingClientRect().height);
    }

    function setCollapsedState() {
      toggleContent.classList.remove('is-expanded');
      toggleContent.style.maxHeight = collapsedHeight + 'px';
      toggle.setAttribute('aria-expanded', 'false');
    }

    function setExpandedState() {
      toggleContent.classList.add('is-expanded');
      toggleContent.style.maxHeight = toggleContent.scrollHeight + 'px';
      toggle.setAttribute('aria-expanded', 'true');
    }

    function syncToggleVisibility() {
      requestAnimationFrame(function () {
        var wasExpanded = toggleContent.classList.contains('is-expanded');
        collapsedHeight = isMobile() ? getMobileCollapsedHeight() : getDesktopCollapsedHeight();

        var needsToggle = isMobile()
          ? toggleContent.scrollHeight > collapsedHeight + 1
          : Boolean(hasAccordionContent && extraCopy && extraCopy.textContent.trim());

        section.classList.toggle('seoSectionCollection--toggle-ready', needsToggle);

        if (needsToggle) {
          if (wasExpanded) {
            setExpandedState();
          } else {
            setCollapsedState();
          }
        } else {
          toggleContent.classList.remove('is-expanded');
          toggleContent.style.maxHeight = '';
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    toggle.addEventListener('click', function () {
      if (!section.classList.contains('seoSectionCollection--toggle-ready')) return;

      var isExpanded = toggleContent.classList.toggle('is-expanded');
      toggleContent.style.maxHeight = isExpanded ? toggleContent.scrollHeight + 'px' : collapsedHeight + 'px';
      toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });

    syncToggleVisibility();
    window.addEventListener('resize', syncToggleVisibility);
  });
});
